import React from 'react'
import { connect } from 'react-redux'
import logoMu from '../../images/logo-sdurdd.svg'
import logoProjekt from '../../images/logo-projekta.svg'
import logoProjektaSeal from '../../images/logo-projekta-seal.svg'

import './header.style.scss'

const Header = ({transaction}) => {
  const sigLogo = (transaction && transaction.signatureType === 'sign') ? logoProjektaSeal : logoProjekt
  return (
    <div className="header">
      {/* <img className="header-logo-left" src={logoMu} alt=""/> */}
      <img className="header-logo-right"src={sigLogo} alt=""/>
    </div>
  )
}

const mapStateToProps = (state) => ({
  transaction: state.transaction.data
})

export default connect(mapStateToProps)(Header)